import MessageDialog from '@srm/ui/message-dialog';
import type { ModalSize } from '@srm/ui/types/ModalSize';
import { useActionSubmit } from '@organisms/actions/useActionSubmit';
import { ActionReasonModal } from './ActionReasonModal';
import type { IActionReason, IActionReasonOptions } from './actionReason';

export interface IActionConfirmModalProps extends IActionReasonOptions {
    header: string;
    message: string;
    okButtonText: string;
    cancelButtonText: string;
    modalSize: ModalSize;
    /** Запрос действия; причина передаётся, только если кнопка её требует. */
    submit: (reason?: IActionReason) => Promise<unknown>;
    completeHandler?: (isSucceed: boolean) => void;
}

/** Подтверждение действия: с `requireReason` — окно причины, иначе обычный вопрос. */
export const ActionConfirmModal = (props: IActionConfirmModalProps) =>
    props.requireReason ? (
        <ActionReasonModal
            header={props.header}
            message={props.message}
            reasonLabel={props.reasonLabel}
            okButtonText={props.okButtonText}
            cancelButtonText={props.cancelButtonText}
            modalSize={props.modalSize}
            completeHandler={props.completeHandler}
            submit={props.submit}
        />
    ) : (
        <PlainConfirm {...props} />
    );

const PlainConfirm = (props: IActionConfirmModalProps) => {
    const { errorText, isBusy, okClick, cancelClick } = useActionSubmit({
        completeHandler: props.completeHandler,
        submit: () => props.submit(),
    });

    return (
        <MessageDialog
            header={props.header}
            message={props.message}
            showOkButton
            showCancelButton
            okButtonText={props.okButtonText}
            cancelButtonText={props.cancelButtonText}
            size={props.modalSize}
            onConfirm={okClick}
            onCancel={cancelClick}
            errorText={errorText}
            loading={isBusy}
        />
    );
};
